<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  html, body {
    height: 100%;
    padding: 0;
    margin: 0;
  }

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  /* 取消横向滚动条*/
  /*.el-scrollbar__wrap {*/
  /*overflow-x: hidden !important;*/
  /*}*/

  .theme-btn:hover {
    background-color: #f3cd04 !important;
    color: #fff !important;
  }

  .theme-btn:visited {
    background-color: #f3cd04 !important;
  }

  .theme-btn {
    border: #f3c01e 1px solid !important;
    background-color: rgba(243, 205, 4, 0.5) !important;
    color: rgba(29, 29, 29, 0.95) !important;
  }

  .success-btn:hover {
    background-color: #46f32d !important;
    color: #fff !important;
  }

  .success-btn:visited {
    background-color: #46f32d !important;
  }

  .success-btn {
    border: #46f32d 1px solid;
    background-color: rgba(70, 243, 45, 0.5) !important;
    color: rgba(29, 29, 29, 0.95) !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue